import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Disable right-click context menu globally
document.addEventListener('contextmenu', (e) => e.preventDefault());

createRoot(document.getElementById("root")!).render(<App />);
